module.exports = __webpack_public_path__ + "assets/img/crm_1.65121aa2.jpg";